export default __webpack_public_path__ + "static/wechat-190e73339a04c51dbe1a0ab0c688f97a.png";